/*
 * Copyright (c) 2023 Anvilor Solutions LLC - All Rights Reserved.
 *
 * The information and source code contained herein is the exclusive property of
 * Anvilor Solutions LLC and may not be disclosed, examined, or reproduced in whole
 * or in part without the explicit written authorization from Anvilor Solutions LLC.
 */

export const SUPPORT_EMAIL_ADDRESS = "info@anvilorsolutions.com";

export const NETWORK_ISSUES_ERROR_MESSAGE = `
We are having trouble reaching our servers right now - you may experience issues
in loading or submitting data. We apologize for the inconvenience. If you have
concerns, please <a href="mailto:${SUPPORT_EMAIL_ADDRESS}">contact support</a>.
`;

export const ANVILOR_FORM_NOT_FOUND_ERROR_MESSAGE = `
  We can&rsquo;t seem to find anything at the URL you've visited. If something seems
  incorrect, please <a href="mailto:${SUPPORT_EMAIL_ADDRESS}">contact support</a>
  for assistance.
`;
